import React from 'react';
import PropTypes from 'prop-types';

// The preview is a convenience: any failure hides it instead of breaking the builder form.
export default class PreviewErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { failed: true };
  }

  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  render() {
    const { failed } = this.state;
    const { children } = this.props;
    return failed ? null : children;
  }
}

PreviewErrorBoundary.propTypes = { children: PropTypes.node.isRequired };
